<template>
  <div>
    <p>Version 1.0 dernière mise à jour le 29 avril 2020</p>

    <h2>Généralités</h2>

    <p>
      La dernière version des CG peut être consultée à l’adresse
      <nuxt-link :to="localePath('/agb')">https://lernpfad.ch/cgv</nuxt-link>
      . Lernpfad.ch met à disposition sur son site lernpfad.ch des produits,
      logiciels et services (ci-après dénommés collectivement « Services »). En
      utilisant ces Services, tu acceptes les présentes Conditions Générales
      (ci-après dénommées « CG »). Suite au développement des Services,
      Lernpfad.ch se réserve le droit de modifier les CG à tout moment et sans
      préavis. Si le client n’accepte pas les nouvelles CG, son compte doit être
      suspendu dans les 30 jours.
    </p>

    <h2>Protection des données</h2>
    <p>
      Notre attitude de base s’appuie sur trois principes : nous collectons
      aussi peu de données que possible (minimisation des données), dans la
      mesure du possible, les données sont stockées sur nos propres serveurs
      (échange de données) nous faisons de notre mieux pour garantir la sécurité
      de tes données (sécurité des données) !
    </p>
    <p>
      Tu peux contacter notre délégué à la protection des données à l’adresse :
      <a href="mailto:datenschutz@lernpfad.ch">datenschutz@lernpfad.ch</a>
      Tu trouveras toutes les autres informations sur la page :
      <nuxt-link
        :to="localePath('/datenschutz')"
        target="_blank"
      >
        https://lernpfad.ch/confidentialite
      </nuxt-link>
      .
    </p>

    <h2>Fourniture des services</h2>

    <p>
      Lernpfad.ch ne garantit pas que les Services offerts correspondent à tes
      exigences ou tes attentes, que l’offre soit disponible de façon
      ininterrompue, opportune, sûre et sans aucune erreur, que les informations
      ou contenus obtenus par l’utilisation des Services soient corrects et
      fiables ni que d’éventuels défauts dans les services soient corrigés.
    </p>

    <p>
      Lernpfad.ch n’endosse aucune responsabilité pour les dommages matériels ou
      immatériels, quels qu’ils soient, encourus à la suite de l’utilisation ou
      l’incapacité d’utilisation, de modifications, d’une indisponibilité
      temporaire ou permanente des Services ou d’autres événements liés aux
      Services.
    </p>

    <p>
      Lernpfad livre une assistance technique à un niveau de « best effort » (au
      mieux) et exclusivement par
      <a href="mailto:info@lernpfad.ch">e-mail</a>
      .
    </p>

    <p>
      Lernpfad.ch se réserve le droit de recourir à tout moment et autant qu’il
      le souhaite aux services de tiers. Une liste exhaustive peut être
      consultée à l’adresse
      <nuxt-link
        :to="localePath('/datenschutz')"
        target="_blank"
      >
        https://lernpfad.ch/confidentialite
      </nuxt-link>
    </p>

    <p>
      Lernpfad.ch évolue continuellement, c’est pourquoi il est toujours
      possible que des parties en soient modifiées ou supprimées. Pour des
      motifs imprévisibles, le service peut être interrompu de façon temporaire
      ou permanente. Nous faisons cependant tout ce qui est en notre pouvoir
      pour que Lernpfad.ch puisse aussi longtemps que possible proposer une
      version de base gratuite.
    </p>

    <h2>Utilisation de Lernpfad.ch</h2>
    <p>
      L’inscription sur lernpfad.ch est gratuite. L’accès à l’application n’est
      pas garanti. Lors de l’utilisation, il faut tenir compte des points
      suivants :
    </p>

    <ul>
      <li>Tu es responsable de la sécurité de ton mot de passe.</li>
      <li>
        Tu as l’obligation de t’assurer que toutes les informations nécessaires
        à l’inscription sont correctes et véridiques, et de les actualiser au
        besoin.
      </li>
      <li>
        Il n’est pas permis d’établir des comptes par un processus automatisé.
      </li>
      <li>
        Il est interdit de te faire passer pour une autre personne sur
        Lernpfad.ch dans le but de tromper quelqu’un.
      </li>
      <li>Toute discrimination est interdite.</li>
      <li>
        Tu te déclares d’accord de ne pas perturber ni interrompre délibérément
        les Services de quelque manière que ce soit.
      </li>
      <li>
        Tu te déclares d’accord de ne pas reproduire, copier, vendre,
        commercialiser ou redistribuer les Services pour quelque raison que ce
        soit.
      </li>
      <li>
        Lernpfad.ch se réserve le droit (sans y être obligé) de vérifier,
        filtrer, modifier, retirer ou effacer des contenus ou des comptes inclus
        dans les services pour prévenir des abus. Si un compte d’utilisateur est
        bloqué, Lernpfad.ch signale par e-mail cette mesure au détenteur du
        compte.
      </li>
    </ul>

    <h2>
      Publication de parcours d’apprentissage (Lernpfad) et droits d’auteur
    </h2>

    <p>
      En créant un Lernpfad, l'auteur(e) se déclare prêt(e) et autorisé(e) à
      publier ces contenus sur le site lernpfad.ch Aucun droit d’auteur n’est
      transmis à la société qui gère le site Lernpfad.ch. L'auteur(e) est
      responsable de la non-violation des droits d'auteur de tiers et en répond
      personnellement. Lernpfad.ch n’est pas responsable du contenu de sites Web
      de tiers auxquels on accède par des liens hypertextes.
    </p>

    <p>
      Tous les parcours d’apprentissage établis ne sont édités que du point de
      vue de la forme par les exploitants. Ils représentent exclusivement
      l’opinion personnelle de leur auteur-e. Leur exactitude n’est en aucun cas
      garantie.
    </p>

    <p>
      Lernpfad.ch offre la possibilité de signaler les violations du droit
      d'auteur sur
      <a href="mailto:info@lernpfad.ch">info@lernpfad.ch</a>
      .
    </p>

    <p>
      En tant qu'exploitant, Lernpfad.ch se réserve le droit de supprimer des
      entrées sans préavis particulier afin de lutter contre les abus.
    </p>

    <p>
      Les informations doivent être utilisées exclusivement pour un usage
      personnel dans le cadre de l'activité d'enseignement, sans consultation
      des ayants droit.
    </p>

    <p>
      L'auteur d'un Lernpfad doit veiller lui-même, lors du partage d'un
      Lernpfad, à ce qu'aucun droit d'auteur de tiers ne soit violé.
    </p>

    <p>
      Le Lernpfad.ch ne versera pas de droits de licence en cas de violation des
      droits d'auteur.
    </p>

    <h2>Clause de défense</h2>

    <p>
      Les présentes CG sont acceptées dans le cadre du processus d’inscription
      et déclarées applicables. Leur validité est exclusive et de durée
      indéterminée, tant qu’elles ne sont pas modifiées ou remplacées d’un
      commun accord.
    </p>

    <h2>Clause de sauvegarde</h2>

    <p>
      Si, pour quelque raison que ce soit, l’une ou plusieurs dispositions des
      présentes CG devaient s’avérer inapplicables ou non valables, la validité
      des autres dispositions ne s’en trouve pas affectée. En lieu et place de
      la disposition caduque, il est convenu d’appliquer, avec effet rétroactif,
      une disposition dont l’effet économique s’approche le plus de la
      disposition souhaitée initialement. Il en va de même pour les lacunes.
    </p>

    <h2>Droit applicable et lieu de juridiction</h2>
    <p>
      Seules les dispositions du droit suisse sont applicables. Le lieu de
      juridiction est à Berne.
    </p>

    <p>
      Tu acceptes de n’utiliser les Services que conformément aux présentes
      dispositions.
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style
  scoped
  lang="scss"
></style>
